'use client';

import React, {FC} from 'react';
import {NextPageContext} from 'next';
import Image from 'next/image';

import {Button} from '@zoefin/design-system/v2';

import styles from './styles.module.scss';

export interface ErrorPageComponentProps {
  statusCode?: number;
}

export interface ErrorPageContext extends NextPageContext {
  err?: {statusCode?: number} & Error;
}

const ErrorPageComponent: FC<ErrorPageComponentProps> = ({statusCode}) => {
  const errorMessage =
    statusCode === 404
      ? 'This page could not be found.'
      : 'An error occurred on server.';

  return (
    <div className={styles.errorPage}>
      <div className={styles.errorPage__imageContainer}>
        <Image
          src="/static/img/onboarding/NoMatch.jpg"
          alt="No Match"
          layout="fill"
        />
      </div>

      <div className={styles.errorPage__messageContainer}>
        <p className={styles.errorPage__messageContainer_message}>
          {statusCode
            ? `${statusCode} | ${errorMessage}`
            : 'An error occurred on client.'}
        </p>
        <Button as="link" href="/">
          Back to home
        </Button>
      </div>
    </div>
  );
};

export default ErrorPageComponent;
